export const disableRefreshButton = () => {
  window.addEventListener('keydown', (event) => {
    if (event.key == 'F5' || event.key == 'f5') {
      alert('Important: ¡Page refresh is not allowed!');
      event.preventDefault();
    }
  });
};
